// src/utils/logger.js
// Production-safe logging helper. It avoids printing raw exception objects in production
// so stack traces, user-entered values, or Firebase internals are not exposed in logs.

const isDev = () => {
  try { return process.env.NODE_ENV !== "production"; }
  catch { return false; }
};

function safeMessage(error) {
  if (!error) return "";
  if (typeof error === "string") return error.slice(0, 160);
  if (error?.code) return String(error.code).slice(0, 80);
  if (error?.name) return String(error.name).slice(0, 80);
  return "error";
}

export function logWarn(label, error) {
  if (isDev()) console.warn(label, error);
  else console.warn(label, safeMessage(error));
}

export function logError(label, error) {
  if (isDev()) console.error(label, error);
  else console.error(label, safeMessage(error));
}

export function logInfo(label, value) {
  if (isDev()) console.log(label, value ?? "");
}
